import React from "react";
import BoardMembers from "../components/BoardMembers";

const AboutUs: React.FC = () => {
  return (
    <div className="mb-10 mt-6">
      <h2 className=" w-11/12 justify-left mx-auto mb-4 text-2xl font-semibold text-left text-white pl-16 pt-7">
        Meet the Team
      </h2>
      <BoardMembers />
    </div>
  );
};

export default AboutUs;
